import { useApi } from '@gravitate-js/the-armory'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useLoadNumbers = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const useLoadNumbersQuery = (filter) =>
    useQuery({ queryKey: ['loadNumbersQuery', filter], queryFn: () => api.post('load_number/overview', { filter }) })

  return {
    useLoadNumbersQuery,
  }
}
